import { UIElements } from '@ansvar-sakerhet/ui';
import styled from 'styled-components';

const IconWithBg = styled(UIElements.Icon)`
  background-color: rgba(2, 62, 82, 0.2);
  padding: 0.2rem;
  height: 1.4rem;
  width: 1.4rem;
  border-radius: 4px;
`;

const DownloadButton = styled(UIElements.Button)`
  background-color: ${({ theme }) => theme.colors.lightGray};
  border: 1px solid ${({ theme }) => theme.colors.black};
  border-radius: 0;
  box-shadow: none;
  font-size: 14px;
  font-weight: 300;
  padding: 0.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-right: 10px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray};
  }
`;

const DeleteButton = styled(UIElements.Button)`
  border-radius: 0;
  box-shadow: none;
  font-size: 14px;
  font-weight: 300;
  padding: 0.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  width: 46px;
  background-color: ${({ theme }) => theme.colors.gray};
  &:hover {
    background-color: ${({ theme }) => theme.colors.gray};
  }
`;

export const S = { ...UIElements, IconWithBg, DownloadButton, DeleteButton };
